import { useVisibilityState } from '@lbcamden/lib-react';
import { useCallback, useState } from 'react';

import { PcfraPerson } from '~/common/types/people';

import { RecordAssessmentDialog } from './RecordAssessmentDialog';

export const useRecordAssessmentDialog = () => {
  const [person, setPerson] = useState<PcfraPerson>();

  const { show, hide, visible } = useVisibilityState();

  const showRecordAssessmentDialog = useCallback((selectedPerson: PcfraPerson) => {
    setPerson(selectedPerson);
    show();
  }, []);

  return {
    showRecordAssessmentDialog,
    recordAssessmentDialog: (
      <RecordAssessmentDialog open={visible} person={person} onClose={hide} />
    ),
  };
};
